import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilRefresher_UNSTABLE as useRecoilRefresher, useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getInitialQueryString } from '@ecp/common/src/utils/good/goodSearchUtil';
import useSearchHistory from '@ecp/common/src/hooks/useSearchHistory';
import { zIndex } from '@ecp/common/src/style/constant';
//import theme from '@ecp/common/src/style/theme/default';
import Paper from '@ecp/common/src/components/paper/Paper';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { withTrendKeywords } from '@fo-recoil/search/selector';
import SearchAutoComplete from '@fo-pages/home/gnb/search/SearchAutoComplete';
import SearchHistory from '@fo-pages/search/components/SearchHistory';
import RecommendKeyword from '@fo-pages/home/gnb/search/RecommendKeyword';
import SearchRealTime from '@fo-pages/search/components/SearchRealTime';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import { SITE_SKYPASS, SITE_KOREANAIR_SAVINGS } from '@ecp/common/src/const/site/siteNumberConst';

const GnbSearchBoard = ({
  keywordList,
  keyword,
  keywordHistoryList,
  onClose,
  setKeywordHistoryList,
  handleDeleteKeywordHistory,
  handleDeleteAllKeywordHistory,
  recommendKeywordList,
  referenceTime,
  realTimeKeywordList,
}) => {
  const navigate = useNavigate();
  const userInfo = useRecoilValue(userInfoState);
  const { addSearchKeyword } = useSearchHistory(userInfo?.userId);
  const refreshTrendKeyword = useRecoilRefresher(withTrendKeywords);
  const { siteNumber } = useSiteInfo();

  useEffect(() => {
    refreshTrendKeyword();
  }, [refreshTrendKeyword]);
  const handleSearch = (keyword) => {
    onClose();
    if (keyword.target === undefined) {
      const updatedList = addSearchKeyword(keyword?.trim?.());
      setKeywordHistoryList(updatedList);
      navigate({
        pathname: '/search',
        search: getInitialQueryString({ searchTerm: keyword?.trim?.(), countPerPage: 60 }),
      });
    } else {
      const chkValue = keyword.target.innerText;
      const updatedList = addSearchKeyword(chkValue);
      setKeywordHistoryList(updatedList);
      navigate({
        pathname: '/search',
        search: getInitialQueryString({ searchTerm: chkValue?.trim?.(), countPerPage: 60 }),
      });
    }
  };

  return (
    <>
      {keyword ? (
        // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
        SITE_SKYPASS === siteNumber || SITE_KOREANAIR_SAVINGS === siteNumber ? (
          <div />
        ) : (
          <SearchWrapper outline elevation round padding={'29px 29px 19px 29px'}>
            <Paper width={'440px'} closable onClose={onClose}>
              <SearchAutoComplete keyword={keyword} keywordList={keywordList} onSearch={handleSearch} />
            </Paper>
          </SearchWrapper>
        )
      ) : (
        <>
          <SearchWrapper outline elevation round padding={'29px 29px 19px 29px'}>
            <SearchHistory
              keywordList={keywordHistoryList}
              onSearch={handleSearch}
              handleDelete={handleDeleteKeywordHistory}
              handleDeleteAll={handleDeleteAllKeywordHistory}
            />
            {recommendKeywordList?.length > 3 &&
              // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
              (siteNumber !== SITE_SKYPASS || siteNumber !== SITE_KOREANAIR_SAVINGS) && (
                <RecommendKeyword recommendKeywordList={recommendKeywordList} handleSearch={handleSearch} />
              )}
            <SearchRealTime
              referenceTime={referenceTime}
              realTimeKeywordList={realTimeKeywordList}
              handleSearch={handleSearch}
            />
          </SearchWrapper>
        </>
      )}
    </>
  );
};
export default GnbSearchBoard;

GnbSearchBoard.propTypes = {
  keywordList: PropTypes.array,
  recommendKeywordList: PropTypes.array,
  keyword: PropTypes.string,
  keywordHistoryList: PropTypes.array,
  currentTab: PropTypes.string,
  onClose: PropTypes.func,
  setKeywordHistoryList: PropTypes.func,
  handleSearch: PropTypes.func,
  handleDeleteKeywordHistory: PropTypes.func,
  handleDeleteAllKeywordHistory: PropTypes.func,
  handleChangeTab: PropTypes.func,
  referenceTime: PropTypes.string,
  realTimeKeywordList: PropTypes.array,
};

const SearchWrapper = styled(Paper)`
  position: fixed;
  z-index: ${zIndex.contextMenu};
  width: 500px;
  align-items: flex-start;
  background: ${(props) => props.theme.color.background.white};
`;
